import React from 'react';
import { Progress } from 'antd';
import './style.scss'

const ProgressCircle = ({completePercentage}) => (
    <div className='progress__container'>
        <Progress trailColor='rgba(47, 128, 237, 0.20)' strokeColor={'#2F80ED'} type="circle" strokeWidth={10} percent={completePercentage ?? 0} size={70} />
    </div>
);
export default ProgressCircle;